###
@deprecated Use `controllerAs` syntax to bind values to controller and not directly to scope
@author Justinas Jurciukonis (justinas.jurciukonis@visma.com)
@company Visma Lietuva

Include template without creating new scope - opposite to ngInclude
###

angular
	.module 'App.Directive'
	.directive 'wmInclude', ($rootScope) ->
		restrict: 'EA'
		templateUrl: (element, attributes) ->
			return $rootScope.$eval(attributes.wmInclude or attributes.src)
